/* unplugin-vue-components disabled */import script from "./userAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./userAvatar.vue?vue&type=script&setup=true&lang=js"

import "./userAvatar.vue?vue&type=style&index=0&id=318409e7&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318409e7"]])

export default __exports__